/**
 * Module for monitoring XMLHttpRequest requests.
 *
 * @module xhr-monitor
 */

/**
 * Variable for storing the authentication token.
 * @type {string|null}
 */
let userToken = null;

/**
 * Monitors all `XMLHttpRequest` requests.
 *
 * @function
 */
export function monitorXHR() {
  (function() {
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
      this.addEventListener('load', function() {
        if (this.responseURL.includes('https://api.eventive.org/people/login')) {
          try {
            const jsonResponse = JSON.parse(this.responseText);
            if (jsonResponse) {
              userToken = jsonResponse.token;

              // Create custom event with optional payload-data as second parameter
              const onTokenUpdateEvent = new CustomEvent('onTokenUpdate', {
                detail: {
                  userData: jsonResponse
                }
              });
              // Trigger your custom event
              document.dispatchEvent(onTokenUpdateEvent);
            }
          } catch (e) {
            console.log('XHR Error parsing response as JSON:', e);
          }
        }
      });
      origOpen.apply(this, arguments);
    };
  })();
}
